import { Timestamp } from "firebase/firestore";
import * as yup from "yup";
import { AnyObject } from "yup/lib/types";
import companiesQuery from "../firestore/Companies.query";
import { requiredKanaAlpNum } from "../utility/ValidationUtilty";

export type Company = {
  id: string;
  displayId: string;
  name: string;
  nameKana: string
  managerName: string;
  managerNameKana: string;
  managerEmail: string;
  usersCount: number;
  createAt: Timestamp;
  updateAt: Timestamp;
  eventType?: Array<string>;
  deleteFlg: boolean;
  adminUserCount?:number;
  messageCount?:number;
}

export const initialCompany = (): Company => {
  return {
    id: "",
    displayId: "",
    name: "",
    nameKana: "",
    managerName: "",
    managerNameKana: "",
    managerEmail: "",
    usersCount: 0,
    createAt: Timestamp.now(),
    updateAt: Timestamp.now(),
    deleteFlg: false
  };
};

export const companySchema = yup.object({
  displayId: yup.string().required().test(
    "",
    "すでに登録されています。",
    (input, context)=>CompaniesValidation(input, context)
  ).length(11).test(
    "",
    "半角数字のみで入力してください。",
    (input, _) => input?.match(/\d{11}/) !== null),
  name: yup.string().required(),
  nameKana: requiredKanaAlpNum,
  managerEmail: yup.string().email().required(),
  managerName: yup.string().required(),
  managerNameKana: requiredKanaAlpNum,
  usersCount: yup.number().min(1).myRequired(),
});

// 団体番号重複チェック
export async function CompaniesValidation(displayId: string | undefined, context: yup.TestContext<AnyObject>) {
  const companies = await companiesQuery.getDisplayIdCompanies(displayId!);
  let valid = true;
  if(companies.length > 0){
    valid = false;
    companies.forEach((company) => {
      const comp = company.data() as Company;
      if(comp.id !== context.parent.id){
        valid = false;
      } else {
        valid = true;
      }
    })
  }
  return valid;
};
